import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import { ResultsPage } from './pages/ResultsPage';
import { UploadPage } from './pages/UploadPage';
import { VERSION } from './version';

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-[radial-gradient(circle_at_top,_#eef7ff,_#f8fafc_48%,_#e2edf6)] text-slate-900">
        <div className="mx-auto max-w-6xl px-4 pt-4 text-right text-xs text-slate-500 sm:px-6 lg:px-8">
          Frontend v{VERSION}
        </div>
        <Routes>
          <Route path="/" element={<UploadPage />} />
          <Route path="/analysis/:analysisId" element={<ResultsPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
